import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppLanguageInterceptor } from '../interceptor/app-language.interceptor';
import { LoaderInterceptor } from '../interceptor/loader.interceptor';
import { AppVersionInterceptor } from '../interceptor/app-version.interceptor';
import { AppTimezoneInterceptor } from '../interceptor/app-timezone.interceptor';
import { ErrorInterceptor } from '../interceptor/error.interceptor';

export const httpInterceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    multi: true,
    useClass: AppLanguageInterceptor,
  },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: LoaderInterceptor },
  {
    provide: HTTP_INTERCEPTORS,
    multi: true,
    useClass: AppVersionInterceptor,
  },
  {
    provide: HTTP_INTERCEPTORS,
    multi: true,
    useClass: AppTimezoneInterceptor,
  },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: ErrorInterceptor },
];
